import { SideBar } from '../../../containers/sideBar';
import { menuKeys } from './config';

export const Sider = () => {
  return <SideBar menuKeys={menuKeys} />;
};
